<template>
<div class="calendar">
    <calendar-filter class="calendar__filter" :initial="params" @change="onFilterChange" :showPast="isPastEventsShown" :key='key'/>

    <z-caption
        v-if="params.type === 'past'"
        tag="p"
        size="xs"
        class="calendar__count"
        >{{ text.count }} {{ nav.count }}</z-caption>

    <div class="calendar__content">
        <results v-if="list && list.length" :data="list" :theme="params.type" />
        <z-not-found v-else :text="text.notFound" />
        <div class="calendar__preloader" v-if="loading">
            <z-preloader />
        </div>
    </div>

    <div class="calendar__pagination">
        <z-pagination
            show-next
            show-prev
            :data="paginationData"
            @change="onPageChange"
        />
    </div>
</div>
</template>

<script>
import CalendarFilter from './components/Filter.vue'
import Results from './components/Results.vue'
import { getEvents } from '@/api/events.js'
import { debounce } from 'throttle-debounce'
import { localize } from '@/utils/i18n.js'
import { queryString } from '@/utils/queryString'

export default {
    name: 'calendar',
    components: {
        CalendarFilter,
        Results
    },
    props: {
        initial: {
            type: Object
        }
    },
    data () {
        return {
            loading: false,
            apiUrl: '/api/calendar-events/',
            params: {
                date: ['', ''],
                type: 'upcoming',
                page: 1
            },
            key: 0,
            componentName: 'events',
            isPastEventsShown: false,
            list: [],
            nav: {
                current: 1,
                total: 1,
                count: 0
            },
            text: {
                count: localize({
                    ru: 'Всего:',
                    en: 'Total:'
                }),
                notFound: {
                    title: localize({
                        ru: 'Мероприятий не запланировано',
                        en: 'No events planned'
                    }),
                    description: localize({
                        ru: 'Обновление последует в ближайшее время',
                        en: 'Update will follow soon'
                    })
                }
            }
        }
    },
    computed: {
        paginationData () {
            return {
                currentPage: this.nav?.current,
                totalItems: this.nav?.count,
                totalPages: this.nav?.total,
                pageRange: 1
            }
        }
    },
    methods: {
        onFilterChange (data) {
            this.params = { ...this.params, ...data }
            this.loading = true
            this.send(this)
        },
        clearEmptyParams () {
            const params = {}
            params.kind = this.params.type
            params.from = Array.isArray(this.params.date) && this.params.date[0] ? this.params.date[0] : ''
            params.to = Array.isArray(this.params.date) && this.params.date[1] ? this.params.date[1] : ''

            Object.keys(params).forEach(function (key, index) {
                if (Array.isArray(params[key])) {
                    if (!params[key].length) delete params[key]
                } else if (!params[key]) {
                    delete params[key]
                }
            })

            return params
        },
        onPageChange (page) {
            this.params.page = page
            this.loading = true
            this.send(this)
        },
        send: debounce(500, _this => {
            queryString(_this.clearEmptyParams())
            getEvents(_this.params)
                .then(res => {
                    _this.list = res.items
                    _this.nav = res.nav
                    _this.loading = false
                })
        }),
        checkArciveList () {
            if (!this.list.length && this.params.type === 'past' && !this.params.date.every(el => el)) {
                this.isPastEventsShown = true
                this.params.type = 'upcoming'
                this.send(this)
            }
        }
    },

    created () {
        if (this.$root.app.components.events) {
            this.list = this.$root.app.components.events.items
            this.nav = this.$root.app.components.events.nav
        }
        this.params = {...this.params, ...this.initial}
        this.params.type = this.initial.type ? this.initial.type : 'upcoming'
        this.checkArciveList()
    }
}
</script>

<style lang="scss">
.calendar {
    &__pagination {
        display: flex;
        justify-content: center;
        @include margin-level(top, M);
    }

    &__filter {
        @include margin-level(bottom, 2XL);
    }

    &__count {
        font-size: 18px;
        line-height: 140%;
        color: $token-colors-black-60 !important;
        margin-bottom: $token-spacers-m;
        margin-top: 0 !important;
    }

    &__content {
        position: relative;
        @include padding-level(bottom, S);
    }

    &__preloader {
        position: absolute;
        background: rgba($token-colors-white, 0.6);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        z-index: 10;
    }
}
</style>
